import { useState, useEffect } from "react";
import { SchoolService } from "../../services/SchoolService";
import { mdiClockOutline } from "@mdi/js";
import Icon from "@mdi/react";

export default function Home() {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const service = new SchoolService();
        const data = await service.getSchoolsWithReservations();
        setSchools(data || []);
        setError(null);
      } catch (err) {
        console.error("Erro ao buscar escolas:", err);
        setError("Erro ao carregar escolas.");
      } finally {
        setLoading(false);
      }
    };

    fetchSchools();
  }, []);

  useEffect(() => {
    const updateClock = () => {
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      setCurrentTime(`${hours}:${minutes}`);
    };

    updateClock();
    const interval = setInterval(updateClock, 60000); // Update every minute

    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return <h2 className="text-center mt-5">Carregando escolas...</h2>;
  }

  if (error) {
    return <h2 className="text-center mt-5 text-danger">{error}</h2>;
  }

  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-center align-items-center">
        <h1 className="fw-bold">Escolas em Tempo Real</h1>
      </div>
      <p className="text-center">
        Confira a situação das escolas em tempo real
      </p>

      <div className="d-flex justify-content-between">
        <div className="d-flex flex-column">
          <div className="d-flex">
            <span className="square bg-secondary"></span>&nbsp;&nbsp; Sem
            reserva
          </div>

          <div className="d-flex mt-2">
            <span className="square bg-warning"></span>&nbsp;&nbsp; Com reserva
          </div>

          <div className="d-flex mt-2">
            <span className="square bg-success"></span>&nbsp;&nbsp; Com reserva
            e checkin
          </div>
        </div>

        <div
          className="d-flex align-items-center justify-content-end mr-5 pr-5 mb-5"
          style={{ marginRight: "100px" }}
        >
          <Icon path={mdiClockOutline} size={1.5} className="me-2" />
          <span className="fs-4 fw-bold">{currentTime}</span>
        </div>
      </div>

      <div className="d-flex flex-wrap justify-content-center mt-4">
        {schools.map((school) => {
          const reservation = school.reservationInfo;
          let bgColor = "gray";
          let guardFullName = "";
          let guardUsername = "";

          if (reservation?.hasReservation) {
            guardUsername = reservation.guardUsername || "";

            // Concatenate name parts
            const nameParts = [
              reservation.guardName,
              reservation.guardSurname,
              reservation.guardLastName
            ].filter(part => part && part.trim() !== '');

            guardFullName = nameParts.join(' ');

            if (reservation.hasCheckin) {
              bgColor = "green";
            } else {
              bgColor = "goldenrod";
            }
          }

          return (
            <div
              key={school._id}
              className="school-card m-2 p-2 text-center fw-bold"
              style={{
                width: "180px",
                borderRadius: "10px",
                color: "#fff",
                backgroundColor: bgColor,
              }}
            >
              {school.name}
              {guardFullName && guardUsername && (
                <div style={{ marginTop: "5px", fontSize: "0.85rem", fontWeight: "normal", color: "#fff" }}>
                  Mat. {guardUsername}
                  <br />
                  {guardFullName}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
